import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Drawer,
	Grid,
	Typography,
	Table,
	TableBody,
	TableRow,
	TableCell,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import {
	MyPATIconButton,
	MyPATProfileBox,
	dateService
} from '../../common';

import ContentData from '../types/ContentData';

const styles = (theme: Theme) => createStyles({
	drawerPaper: {
		width: 260,
	},

	drawerHeader: {
		display: 'flex',
		flexWrap: 'nowrap',
		padding: theme.spacing.unit,
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		backgroundColor: theme.palette.grey[50],
	},
	drawerTitle: {
		flex: '1 1 auto',
		fontWeight: theme.typography.fontWeightRegular,
	},
	iconRoot: {
		fill: theme.palette.text.secondary,
		// opacity: 0.5,
		margin: 0,
	},

	drawerBody: {
		padding: theme.spacing.unit,
	},

	fwMedium: {
		fontWeight: theme.typography.fontWeightMedium,
	},
	fwRegular: {
		fontWeight: theme.typography.fontWeightRegular,
	},

	detailsTitle: {
		fontWeight: theme.typography.fontWeightMedium,
		margin: `${theme.spacing.unit * 1.5}px 0 ${theme.spacing.unit / 2}px`,
	},
	detailsTable: {
		'& tbody': {
			'& tr': {
				height: 'auto',
				'& td': {
					padding: `${theme.spacing.unit / 2}px 0`,
					border: 0,
					'&:last-child': {
						paddingRight: 0,
					},
				},
			},
		},
	},
});

//@ts-ignore
interface ContentDetailsDrawerProps extends WithStyles<typeof styles> {
	classes: any,
	isDetailsDrawerOpen: boolean,
	content: ContentData,
	contentType: any,
	contentSubtype: any,
	onDetailDrawerClose: () => void,
}

const ContentDetailsDrawer = (props: ContentDetailsDrawerProps) => {

	function getConceptsTagged() {
		let concepts = "";

		_.map(_.get(content, 'subjects', []), s => {
			s.chapters.forEach(c => {
				c.concepts.forEach(cc => {
					if (!concepts) {
						concepts + ", ";
					}
					concepts += (cc.conceptId && cc.conceptId.name) || '';
				})
			})
		});

		return concepts;
	}


	const {
		classes,
		isDetailsDrawerOpen,
		onDetailDrawerClose,
		content,
		contentType,
		contentSubtype
	} = props;

	return (
		<Drawer
			anchor="right"
			open={isDetailsDrawerOpen}
			onClose={onDetailDrawerClose}
			ModalProps={{
				disableBackdropClick: true
			}}
			classes={{ paper: classes.drawerPaper }}
		>
			<Grid container>
				<Grid item xs={12} className={classes.drawerHeader}>
					<Typography variant="h6" noWrap className={classes.drawerTitle}>{_.get(content, 'subjects[0].chapters[0].concepts[0].conceptId.name', "")}</Typography>
					<MyPATIconButton buttonVariant="transparent" onClick={onDetailDrawerClose}>
						<CloseIcon classes={{ root: classes.iconRoot }} />
					</MyPATIconButton>
				</Grid>

				<Grid item xs={12} className={classes.drawerBody}>
					<Typography variant="body1" className={classes.detailsTitle}>General Info</Typography>
					<Table className={classes.detailsTable}>
						<TableBody>
							<TableRow>
								<TableCell>Content ID</TableCell>
								<TableCell>{_.get(content, 'contentId', "-")}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Type</TableCell>
								<TableCell>{contentType[_.get(content, 'contentTypeCode', "-")]}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Sub Type</TableCell>
								<TableCell>{contentSubtype[_.get(content, 'contentSubTypeCode', "-")]}</TableCell>
							</TableRow>
							{
								_.get(content, 'status', "") == "PUBLISHED" && (
									<TableRow>
										<TableCell>Published</TableCell>
										<TableCell>{dateService.timeDate(_.get(content, 'updatedAt', "-")) /*12:29 PM Oct 28*/}</TableCell>
									</TableRow>
								)
							}
							<TableRow>
								<TableCell>Last Modified</TableCell>
								<TableCell>{dateService.timeDate(_.get(content, 'updatedAt')) /*12:29 PM Oct 28*/}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Created</TableCell>
								<TableCell>{dateService.timeDate(_.get(content, 'createdAt')) /*12:29 PM Oct 28*/}</TableCell>
							</TableRow>
						</TableBody>
					</Table>

					<Typography variant="body1" className={classes.detailsTitle}>
						Concepts Tagged
          </Typography>
					<Typography variant="body2" className={classes.fwRegular}>
						Limits
          </Typography>
					<Typography variant="body2" className={classes.fwRegular} color="textSecondary">
						{getConceptsTagged()}
					</Typography>

					<Typography variant="body1" className={classes.detailsTitle}>Author(s)</Typography>
					{
						_.map(_.get(content, 'authors', []), (ca, i) => (
							<MyPATProfileBox key={i}
								avatarProps={{
									src: ca.profileImage,
									alt: '',
									title: '',
									style: { height: 32, width: 32 }
								}}
								profileBoxProps={{
									style: { marginBottom: 8 }
								}}
								profileTitleProps={{
									variant: 'body2',
									classes: { root: classes.fwRegular },
								}}
								title={ca.fullName}
								caption="-"
								variant="inline"
							/>
						))
					}

					{
						_.get(content, "status", "") == "PUBLISHED" && (
							<>
								<Typography variant="body1" className={classes.detailsTitle}>Published By</Typography>
								<MyPATProfileBox
									avatarProps={{
										src: _.get(content, 'aclMetaData.updatedBy.id.profileImage', ''),
										alt: '',
										title: '',
										style: { height: 32, width: 32 }
									}}
									profileBoxProps={{
										style: { marginBottom: 8 }
									}}
									profileTitleProps={{
										variant: 'body2',
										classes: { root: classes.fwRegular },
									}}
									title={_.get(content, 'aclMetaData.updatedBy.id.fullName', '')}
									caption="-"
									variant="inline"
								/>
							</>
						)
					}

					<Typography variant="body1" className={classes.detailsTitle}>Shared With</Typography>
					{
						_.map(_.get(content, 'aclMetaData.allowedTo', []), (cs, i) => {

							if (!_.get(cs, 'user.id._id', _.get(cs, 'userGroup.id._id', ''))) {
								return;
							}

							return (
								<MyPATProfileBox key={i}
									avatarProps={{
										src: _.get(cs, 'user.id.profileImage', ''),
										alt: '',
										title: '',
										style: { height: 32, width: 32 }
									}}
									profileBoxProps={{
										style: { marginBottom: 8 }
									}}
									profileTitleProps={{
										variant: 'body2',
										classes: { root: classes.fwRegular },
									}}
									title={_.get(cs, 'user.id.fullName', _.get(cs, 'userGroup.id.name', ''))}
									caption="-"
									variant="inline"
								/>
							)
						})
					}

					<Typography variant="body1" className={classes.detailsTitle}>Tags</Typography>
					<Table className={classes.detailsTable}>
						<TableBody>
							{
								_.map(_.get(content, 'tags', []), (t, i) => (
									<TableRow key={i}>
										<TableCell>{_.get(t, 'relation.name', '')}</TableCell>
										<TableCell>{_.get(t, 'values', []).join(", ")}</TableCell>
									</TableRow>
								))
							}
						</TableBody>
					</Table>

					<Typography variant="body1" className={classes.detailsTitle}>
					</Typography>
					<Typography variant="body2" className={classes.fwRegular}>
					</Typography>
				</Grid>
			</Grid>
		</Drawer>
	)
}




const mapStateToProps = (state: any) => {
	let ct: any = _.get(state, "mylibraryData.contentType.list", []);
	let ctt: any = {};
	ct.forEach((c: any) => {
		ctt[c.code] = c.name;
	});


	let cst: any = _.get(state, "mylibraryData.contentSubtype.list", []);
	let cstt: any = {};
	cst.forEach((c: any) => {
		cstt[c.code] = c.name;
	});


	return {
		contentType: ctt,
		contentSubtype: cstt,
	}
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(ContentDetailsDrawer));